import clsx from 'clsx';
import React from 'react';

type Props = {
  children: React.ReactNode;
  className?: string;
  size?: 'small' | 'medium' | 'large';
  color?: 'black' | 'white';
  weight?: 'normal' | 'bold';
  [key: string]: any;
};

export default function H2({
  children,
  className,
  size = 'medium',
  color = 'black',
  weight = 'bold',
  ...rest
}: Props) {
  const sizeClasses = {
    small: 'text-sm',
    medium: 'text-xl lg:text-4xl',
    large: 'text-2xl lg:text-5xl'
  };

  const colorClasses = {
    black: 'text-letters-black dark:text-white',
    white: 'text-white dark:text-letters-black'
  };

  const weightClasses = {
    normal: 'font-normal',
    bold: 'font-bold'
  };

  return (
    <h2
      {...rest}
      className={clsx(
        sizeClasses[size],
        weightClasses[weight],
        'leading-snug',
        colorClasses[color],
        className
      )}
    >
      {children}
    </h2>
  );
}
